module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q3-lockup.0642da63.png";